// mejora-web F1: el dato horarios.sala ya suele venir como «Sala A» y la
// plantilla i18n antepone «Sala/Room/Salle/Зал», lo que producía «Sala Sala A».
// Quitamos el prefijo del dato (en cualquiera de los 4 idiomas) y dejamos
// que la plantilla ponga el del idioma actual: «Sala A», «Room A», «Salle A».
const PREFIJO = /^\s*(sala|room|salle|зал)\s+/i;

export function etiquetaSala(sala, t) {
  if (!sala) return '';
  const nombre = String(sala).replace(PREFIJO, '').trim();
  return nombre ? t('reservas.sala_label', { sala: nombre }) : String(sala);
}
